// src/modules/prode-skeleton.js — placeholder de la pantalla Prode (/prode/).
//
// FASE 4 · DT-BJ (parpadeo Prode). Mientras llegan los datos del fixture
// (loadProdeData + getPredicciones), la pantalla muestra un skeleton
// estructural en lugar del placeholder texto plano "Cargando el Mundial 2026…"
// que generaba parpadeo. Cuando los datos resuelven, prode.js monta el sandbox
// completo en Shadow DOM y el contenido real reemplaza al skeleton.
//
// Vive en el DOM regular (no en Shadow DOM, igual que el placeholder original)
// porque se pinta ANTES del attachShadow. Usa solo variables CSS globales del
// theme (--white, --celeste, --text-muted, --font-heading) — no depende del
// CSS del sandbox.

const PULSE_STYLE = `<style>
    @keyframes prodeSkelPulse { 0%, 100% { opacity: .5; } 50% { opacity: .9; } }
    .prode-skel { animation: prodeSkelPulse 1.25s ease-in-out infinite; background: rgba(255,255,255,.045); border: 1px solid rgba(255,255,255,.105); border-radius: 9px; }
</style>`;

// Skeleton de /prode/ — título corto (mismo que el sandbox vivo) + tabs (3) +
// subtabs (2) + 6 placeholder match cards. El encabezado común
// (renderActiveGroupBar) lo prepende renderProde en light DOM, fuera de acá.
export const buildProdeSkeleton = () => `
    ${PULSE_STYLE}
    <div class="view-enter" style="width: 100%; max-width: 760px; margin: 0 auto; padding: 18px 14px 90px; animation: fadeIn 0.4s ease-out forwards;">
        <div style="display: block; margin: 2px 0 12px; padding: 0.85rem 0.7rem; border: 0; border-radius: 18px; background: linear-gradient(135deg, #5e93c2 0%, #75aadb 52%, #9bc4e6 100%); box-shadow: 0 16px 34px rgba(117,170,219,.2), 0 0 24px rgba(117,170,219,.22); color: #06111f; font-family: var(--font-heading); font-weight: 900; font-size: clamp(13px, 4.3vw, 19px); line-height: 1.15; text-align: center; white-space: nowrap; overflow: hidden;">Partido a Partido + Tus Predicciones</div>
        <div class="prode-skel" style="min-height: 50px; border-radius: 13px; margin: 10px 0 12px;"></div>
        <div class="prode-skel" style="min-height: 50px; border-radius: 13px; margin-bottom: 10px;"></div>
        ${Array.from({ length: 6 }, () => `<div class="prode-skel" style="margin-bottom: 8px; min-height: 70px; border-radius: 12px;"></div>`).join('')}
    </div>
`;
